import React from 'react';
import PropTypes from 'prop-types';
import './_styles_/EnvironmentConfigurationTableRow.css';

EnvironmentConfigurationTableRow.propTypes = {
    configKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};

function EnvironmentConfigurationTableRow(props) {
    const {
        configKey,
        value,
    } = props;
    return (
        <div className="detail-list-row env-configuration-table-row">
            <div className="config-cell env-configuration-table-row--config-key">{configKey}</div>
            <div className="config-cell env-configuration-table-row--value">{value}</div>
        </div>
    );
}

export default EnvironmentConfigurationTableRow;
